import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef, useState, } from 'react';
import { cn } from '../utils/cn.js';
import { Input } from './FormControls.js';
export function Combobox({ options, value, onValueChange, placeholder, disabled, className, ...rest }) {
    const listId = useId();
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');
    const rootRef = useRef(null);
    const selected = options.find((o) => o.value === value);
    const filtered = options.filter((o) => o.label.includes(query));
    useEffect(() => {
        if (!value) {
            setQuery('');
        }
        else if (selected) {
            setQuery(selected.label);
        }
    }, [value, selected]);
    useEffect(() => {
        const onDoc = (e) => {
            if (!rootRef.current?.contains(e.target))
                setOpen(false);
        };
        document.addEventListener('mousedown', onDoc);
        return () => document.removeEventListener('mousedown', onDoc);
    }, []);
    return (_jsxs("div", { className: cn('sak-combobox', className), ref: rootRef, children: [_jsx(Input, { role: "combobox", "aria-expanded": open, "aria-controls": listId, "aria-autocomplete": "list", disabled: disabled, placeholder: placeholder, value: open ? query : (selected?.label ?? (value ? query : '')), onChange: (e) => {
                    setQuery(e.target.value);
                    setOpen(true);
                }, onFocus: () => setOpen(true), ...rest }), open && !disabled ? (_jsx("ul", { className: "sak-combobox__list", id: listId, role: "listbox", children: filtered.map((opt) => (_jsx("li", { role: "option", "aria-selected": opt.value === value, className: "sak-combobox__option", tabIndex: 0, onMouseDown: (e) => {
                        e.preventDefault();
                        onValueChange?.(opt.value);
                        setQuery(opt.label);
                        setOpen(false);
                    }, children: opt.label }, opt.value))) })) : null] }));
}
//# sourceMappingURL=Combobox.js.map